export default "/_next/static/chunks/fonts/Muli-Bold-41ef56b688667f0b7c794fef1a4c6705.ttf";